export const iconFontAwesomeTimeClock = (
	<i className="fa-solid fa-clock"></i>
);
